const ReqKuotaPemetaan = {
    idJadwalCbt: null,
    idKelas:null,
    kodeTahunAjaran: null,
    kodeTipeCbt: null
}

export default ReqKuotaPemetaan;